import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import "./NewMethod.css";
import { ReactComponent as DatabaseLogo } from "../../../images/database.svg";
import { ReactComponent as FeaturesLogo } from "../../../images/features.svg";
import { ReactComponent as ModalLogo } from "../../../images/modal.svg";
import { ReactComponent as TrainingLogo } from "../../../images/training.svg";
import { ReactComponent as AnalysisLogo } from "../../../images/analysis.svg";
import Button from "../../../components/PrimaryButton.js";
import Fade from "react-reveal/Fade";
import { motion } from "framer-motion";

const useStyles = makeStyles({
  cell: {
    display: "inline",
    position: "relative",
    bottom: 12,
    margin: 10,
  },
  startButton: {
    height: 40,
    width: 100,
  },
  saveButton: {
    float: "right",
    marginRight: 15,
    marginTop: 30,
    fontSize: "1rem",
  },
});

const tableStyles = makeStyles(
  {
    root: {
      borderColor: "#FFB4A7",
    },
  },
  { name: "MuiTableCell" }
);

function createData(logo, name) {
  return { logo, name };
}

const rows = [
  createData(<DatabaseLogo />, "Data"),
  createData(<FeaturesLogo />, "Features"),
  createData(<ModalLogo />, "Modal"),
  createData(<TrainingLogo />, "Training"),
  createData(<AnalysisLogo />, "Analysis"),
];

const NewMethod = () => {
  const classes = useStyles();
  const tableStyle = tableStyles();
  return (
    <>
      {/* <motion.div
        exit={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
      > */}
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Module</TableCell>
              <TableCell align="right">Name</TableCell>
              <TableCell align="right">Last Updated</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  <div>
                    {row.logo}
                    <div className={classes.cell}>{row.name}</div>
                  </div>
                </TableCell>
                <TableCell></TableCell>
                <TableCell align="right"></TableCell>
                <TableCell align="right"></TableCell>
                {row.name === "Data" && (
                  <TableCell align="right">
                    <Link
                      to="/methods/new-method/data"
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        styleClasses={classes.startButton}
                        innerText="Start"
                      />
                    </Link>
                  </TableCell>
                )}
                {row.name !== "Data" && (
                  <TableCell align="right">
                    <Button
                      isDisabled
                      styleClasses={classes.startButton}
                      innerText="Start"
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        styleClasses={classes.saveButton}
        innerText="SAVE & SHARE"
        isDisabled={true}
      ></Button>
      {/* </motion.div> */}
    </>
  );
};

export default NewMethod;
